var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.375 14.3333C6.91667 14.3333 6.455 14.2814 5.99 14.1775C5.525 14.0736 5.04917 13.9241 4.5625 13.7291C4.72917 12.0486 5.21528 10.4791 6.02083 9.02081C6.82639 7.56248 7.86111 6.27776 9.125 5.16665C7.59722 5.94443 6.27445 6.9722 5.15667 8.24998C4.03889 9.52776 3.2575 10.9861 2.8125 12.625C2.75694 12.5833 2.705 12.5383 2.65667 12.49L2.5 12.3333C1.84722 11.6805 1.35083 10.9514 1.01083 10.1458C0.670833 9.34026 0.500556 8.49998 0.5 7.62498C0.5 6.68054 0.6875 5.77776 1.0625 4.91665C1.4375 4.05554 1.95833 3.29165 2.625 2.62498C3.75 1.49998 5.20833 0.767482 7 0.427482C8.79167 0.0874817 11.3056 0.0560925 14.5417 0.333315C14.7917 3.65276 14.75 6.18415 14.4167 7.92748C14.0833 9.67081 13.3611 11.0978 12.25 12.2083C11.5694 12.8889 10.8089 13.4133 9.96833 13.7816C9.12778 14.15 8.26333 14.3339 7.375 14.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEco);
export default __webpack_public_path__ + "static/media/eco.e1ff711ffd14c9cc6675d8134426af9e.svg";
export { ForwardRef as ReactComponent };